import { queryOptions, useQuery } from '@tanstack/react-query';

import { getMyClients } from '../api';

// Shared options so the hook and loader-side `ensureQueryData` use the same
// cache entry — the current user's clients are stable per session, fetched once.
export const clientsQueryOptions = () =>
  queryOptions({
    queryKey: ['clients', 'my'],
    queryFn: getMyClients,
    staleTime: Infinity,
  });

export const useMyClients = () => useQuery(clientsQueryOptions());
